function updateSelection(state, selection) {
    state.selected = selection
}

export default {
    updateSelection
}
